import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=b921f190&scoped=true"
import script from "./custom.vue?vue&type=script&setup=true&lang=js"
export * from "./custom.vue?vue&type=script&setup=true&lang=js"
import style0 from "./custom.vue?vue&type=style&index=0&id=b921f190&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b921f190",
  null
  
)

export default component.exports